import { Component } from '@angular/core';
import { HttpClient} from '@angular/common/http'
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig } from "@angular/material/legacy-dialog";
import { ApiService } from './api.service';
import { BreakpointObserver, Breakpoints,BreakpointState } from '@angular/cdk/layout';


// import { Observable } from 'rxjs';

// import { timer } from 'rxjs/observable/timer';
import {interval, Observable, of, timer} from 'rxjs';

// import * as windyInit from '../assets/libBoot.js';

// NO import {} from '../assets/leaflet/leaflet.js';
// NO import leaflet from 'leaflet';
// NO ? import * as L from 'leaflet';  
import leaflet from 'leaflet';    // Sembra funzionare

// declare leaflet variable
declare let L;
declare var windyInit: any;

import * as moment from 'moment';
import { DialogComponent } from './dialog/dialog.component';


// ATTENZIONE, 23/05/2023 Commento per provare a compilare dopo upgrade v15
// import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

// import { PlayState } from '@angular/core/src/render3/interfaces/player';
// import { SSL_OP_SSLEAY_080_CLIENT_DH_BUG } from 'constants';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  title = 'livetrack';
  heightExp:string;
  isScreenLarge: boolean;
  isScreenVerySmall: boolean;

  // Mappa e layer
  map: any;
  windyAPI : any;

  id_event: number = 0;
  
  trackPolylineMaxAge: number = 1800; // Default 30minuti, diventa trackingInterval * 2
  boatLayerUpdateEpoch : number = 0;      

  routeMarkers: any[] = [];
  routeMarkerIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><circle cx="24" cy="24" r="24" stroke="black" stroke-width="1" fill="red" /></svg>`;
  routePolylineLayer: any = 0;

  // Info boat
  boatInfo:any = 0;
  boatInfoX: number = 0;
  boatInfoY: number = 0;
  boatInfoWidth: number = 220;
  boatInfoHeight: number = 200;
  boatInfoVisible : boolean = false;
  boatInfoVisibleStyle: string = "hidden";
  boatInfoId: number = -1;

  // Data table
  columnsToDisplay: string[] = ['name', 'sailn'];

  //---------------------------------------------------------------------------
  constructor(private http: HttpClient,public api:ApiService, public breakpointObserver: BreakpointObserver,private dialog:MatDialog){ 
    /*
    // Registro icona custom per utilizzo con AngularMaterial icon
    this.matIconRegistry.addSvgIcon(
      `boat`,
      `/assets/boat-icon.svg`
    );
    */
    // ATTENZIONE, NON FUNZIONA cerco di aprire il dialogo nel costruttore e non in ngOnInit() 
    // per evitare errori nel chang detection di Angular..senza successo
    this.openDialog();
  }
  //---------------------------------------------------------------------------
  ngOnInit(){
    
    this.heightExp = "200";
    this.heightExp = "100%";

    
    // this.isScreenLarge = true;
    // this.isScreenVerySmall = false;
    
    this.breakpointObserver.observe(['(min-width: 960px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        console.log('AppComponent :: Viewport is 1023px or over!');
        this.isScreenLarge = true;
      }
      else {
        console.log('AppComponent :: Viewport is getting smaller than 1023px !');
        this.isScreenLarge = false;
      }
    })

    // this.breakpointObserver.observe(['(min-width: 400px)']).subscribe((state: BreakpointState) => {
    //   if (state.matches) {
    //     console.log('AppComponent :: Viewport is 400px or over!');
    //     this.isScreenVerySmall = false;
    //   }
    //   else {
    //     console.log('AppComponent :: Viewport is getting smaller than 400px !');
    //     this.isScreenVerySmall = true;
    //   }
    // })
    
    
    // this.openDialog();
    // this.openDialog();

    // TODO ATTENZIONE RIMUOVERE RETURN, SOLO PER EVITARE WINDY
    // this.dialog.closeAll();
    // return;

    // ATTENZIONE, posticipo creazione mappa a quando effettivamente disponibili dati evento ed imbarcazioni
    // Inizializzo mappa
    // this.mapInit();
    
    // Registro observable (callback) ricezione nuovi dati tracking
    this.api.boatsObservable.subscribe(data => {
      // console.log(JSON.stringify(data));
      
      // Purtroppo posso ricevere i dati barca prima di avere disponibili i dati evento
      // Inizializzo la mappa solo quando sono disponibile i dati evento
      // if ((this.map==null)&&(this.api.event != null)) {
      // console.log("this.api.mapReady="+this.api.mapReadyStatus + " | this.api.event="+this.api.event);
     
      // if ((this.api.mapReadyStatus==-1)&&(this.api.event != null)) {
      if ((this.api.mapReadyStatus==-1)&&(this.api.eventReadyStatus > 0)) {
        // ATTENZIONE NON CANCELLARE SOLO PER TEST
        this.api.mapReadyStatus = 0; // Semaforo avvio inzializzazione
        // console.log("INIT");
        this.mapInit();
        // ATTENZIONE this.map NON SEMBRA PRONTA!!!!
        // var latlng = this.map.getCenter()
        // this.api.mapMouseLat = latlng.lat;
        // this.api.mapMouseLon = latlng.lat;
      }
      // else
      //   console.log("NO INIT - this.api.mapReady="+this.api.mapReadyStatus)

      // Ridisegno la mappa solo se effettivamente creata
      // if (this.map!=null){
      if (this.api.mapReadyStatus>=1){
        // console.log("REDRAW");
        this.mapRedraw(data);
        // NOO Qui da molto fastidio....
        // this.dialog.closeAll();
        // ATTENZIONE VALUTARE QUANDO CHIUDERE DIALOGO
        // console.log("this.dialog.closeAll !!!");
        this.api.mapReadyStatus = 2;
        this.dialog.closeAll();
      }
      // else
      //   console.log("NO REDRAW - this.api.mapReady="+this.api.mapReadyStatus)
    })

    // Sottoscrivo notifica in caso di cambiamento LeaderBoard
    // Questo accade ad ogni nuovo dato e in caso di selezione utente
    this.api.boatsLeaderBoardsObservable.subscribe(data => {
      // ATTENZIONE mi serve questo evento perchè se l'utente filtra o nasconde le imbarcazioni nella
      // leaderboard voglio nascondere i marker e tracce prima di aspettare un nuovo evento di lettura
      // dati da reload interval o playback
      // Marker e polilienee sono salvati in api.boatsLayer[] anche se non sono aggiunti alla mappa
      // In questo modo posso controllarne la visibilità senza ricaricare tutto
      for (let i=0;i<this.api.boatsLayer.length;i++) {
        // Se non è presente alcun marker allora sicuramente non esiste polilinea e non devo controllare visibilità
        if (this.api.boatsLayer[i].marker == 0)
          continue;
        
        // Voglio rendere visibili solo le barche presenti nella leaderboard e visibili
        let layerVisible = this.map.hasLayer(this.api.boatsLayer[i].marker);
        let boatVisible = ((this.api.boats[i].visible) && (this.api.boats[i].name.toUpperCase().includes(this.api.boatLeaderBoardFilterValue.toUpperCase())));
        if ((boatVisible == true) && (layerVisible == false)) {
          this.api.boatsLayer[i].marker.addTo(this.map);
          if (this.api.boatsLayer[i].polyline != 0)
            this.api.boatsLayer[i].polyline.addTo(this.map);
        } 
        else if ((boatVisible == false) && (layerVisible == true)) {
          this.map.removeLayer(this.api.boatsLayer[i].marker); 
          if (this.api.boatsLayer[i].polyline != 0)
            this.map.removeLayer(this.api.boatsLayer[i].polyline); 
        }  

        // Controllo eventuale visibilità traccia completa
      //if ((boatVisible==true)&&(this.api.boats[i].fullTrackVisible == true)) {
        if ((boatVisible==true)&&(this.api.boats[i].fullTrackVisible == true)) {

          this.showBoatFullTrack(i); // Modifica punti traccia !!
        }
      }
      // console.log("this.api.boatsLeaderBoardsObservable has updated visibility");
      // console.log(JSON.stringify(data));
      // console.log("app::boatsLeaderBoardsObservable");
    })

    // Sottoscrivo notifica evento di selezione/deselezione imbarcazione segnalato da api. 
    this.api.messageServiceObservable.subscribe(message =>{
      // console.log("messageServiceObservable::" + message);
      
      // Mostro/nascondo pannello informazioni imbarcazione sopra posizione icona
      // Mostro/nascondo traccia imbarcazione selezionata.
      let boatId = message.id;
      let event = message.event;

      // Se la barca non ha marker allora non faccio nulla per evitare errori
      // if (this.api.boatsLayer[boatId].marker == 0)
      //   return;

      if (event=="mouseenter") {
        if (this.api.boatsLayer[boatId].marker != 0) {
          let position: any;
          position = L.point(this.map.latLngToContainerPoint(this.api.boatsLayer[boatId].marker._latlng));
          this.showBoatInfo(boatId,position.x,position.y); 
        } 
        else {
          this.showBoatInfo(boatId,300,65);   // y= posizione pannello 
        }
        
      } 
      else if (event=="mouseleave") {
        this.hideBoatInfo(boatId); 
      }
      
      // TODO Forse conviene non ridisegnare sempre tutto..
      // Riaggiorno tutte le tracce !!
      for (let i=0;i<this.api.boats.length;i++) {
        if (this.api.boats[i].fullTrackVisible == true)
          this.showBoatFullTrack(i);
        else
          this.hideBoatFullTrack(i);
      }

    })

    // this.api.reloadInterval = 300;           // Imposto frequenza aggiornamento api per dati imbarcazione
    this.api.reloadInterval = 120;              // 26/05/2023 Ridotto intervallo aggiornamento api per dati imbarcazione da 5 a 2 minuti

    this.api.playbackEnabledAutoDetect = true;  // true
    this.api.update();                          // Forzo la api a rileggere i dati subito, senza aspettare intervallo
    
    /*
    // NON CANCELLARE, DEMO Leaflet
    const map = L.map('map').setView([51.505, -0.09], 13);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);
    */

    // ATTENZIONE devo creare il timer fuori dalla WindyInit perchè altrimenti non vengono
    // rilevati gli eventi nel ChangeDetector di Angular, il timer non viene "controllato"
    // se non lo inizializzo direttamente nella funzione ngOnInit()
    timer(10000,1000).subscribe(()=>{
      // console.log("angular timer tick");
      this.mainTimer(this);
      // NOOOOO this.dialog.closeAll();
      // console.log(document.getElementById("mobile-ovr-select").style.color="blue";)
    });

  } 
  //---------------------------------------------------------------------------
  mapInit(){
    
    // Impostazioni Windy
    // console.log("windy options - this.api.event.centerlatitude="+this.api.event.centerlatitude);
    // console.log("windy options - this.api.event.centerlongitude="+this.api.event.centerlongitude);
    // console.log("windy options - this.api.event.startzoom="+this.api.event.startzoom);
    const options = {
      key: 'NZmxD8gVVnUU1MklgdrN1NJeAESAUYe8', // Required: API key
      // Put additional console output
      verbose: false, 
      // verbose: true,
      // Optional: Initial state of the map
      // lat: 43.625, //43.135065496929165, lng: 7.918395996093749
      // lon: 8.5,
      // zoom: 8
      lat: this.api.event.centerlatitude,
      lon: this.api.event.centerlongitude,
      zoom: this.api.event.startzoom
    }
    
    // console.log("A moment before WindyInit...")
    windyInit( options, windyAPI => {
      // Assegno alla variabile esterna l'istanza della mappa leaflet restituita da Windy
      // Nota che la loro assegnazione era const { map } = windyAPI; !!!
      
      // console.log ("Inside WindyInit callback...1");
      this.windyAPI = windyAPI; 
      this.map = windyAPI.map;
      // Tentativo di rendere disponibili picker e utils....
      const { picker, utils, broadcast,overlays } = this.windyAPI;
      // const { picker, utils, broadcast, map, overlays } = windyAPI

      this.map.options.minZoom = 4;
      this.map.options.maxZoom = 17;

      // Layer aggiuntivo per visualizzare dettagli oltre il massimo del background windy
      // var mapInit = L.tileLayer('http://b.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      //   attribution: 'Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, ',
      //   minZoom: 12,
      //   maxZoom: 17
      // });
      // topLayer.setOpacity('0'); // Per adesso NON lo rendo visible
      // topLayer.addTo(this.map);

      // Abilitazione layer aggiuntivi per zoom elevati + simboli nautici
      // TODO ATTENZIONE VERIFICARE SOVRACCARICO/MEMORIA/PRESTAZIONI SU DISPOSITIVI PORTATILI
      var OpenStreetMap_Mapnik = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      });      
      OpenStreetMap_Mapnik.setOpacity('0'); // Per adesso NON lo rendo visible
      OpenStreetMap_Mapnik.addTo(this.map);

      // var OpenSeaMap  = L.tileLayer('https://tiles.openseamap.org/seamark/{z}/{x}/{y}.png', {
      //   attribution: 'Map data: &copy; <a href="http://www.openseamap.org">OpenSeaMap</a> contributors'
      // });
      // OpenSeaMap.setOpacity('0'); // Per adesso NON lo rendo visible
      // OpenSeaMap.addTo(this.map);

      // ATTENZIONE NON CANCELLARE, sembra funzionare...
      picker.on('pickerOpened', latLon => {
        // Picker has been opened at latLon coords
        let { lat, lon, values, overlay } = picker.getParams();
        let windObject = this.windyAPI.utils.wind2obj( values )
        console.log( windObject )
        // console.log(picker.getParams());
        
        // ATTENZIONE TODO per dispositivi mobili bisognere disabilitare il picker
        // this.windyAPI.picker.close();
      })


      var _parentContext = this;
          // newMarker.on('mouseover', function(e){
          //   // _parentContext.showBoatInfo(i,e.originalEvent.clientX,e.originalEvent.clientY);
          //   _parentContext.showBoatInfo(i,e.originalEvent.pageX,e.originalEvent.pageY);
          //   // console.log(e);
          // });
          // newMarker.on('mouseout', function(e){
          //   _parentContext.hideBoatInfo(i);
      this.map.on('click', function(e) {
        // NON FUNZIONA 
        /*
        e.originalEvent.stopPropagation()
        e.originalEvent.preventDefault()
        _parentContext.hideBoatInfo(0);
        console.log(e.latlng + " zoom="+this.getZoom());
        return false;
        */
       _parentContext.hideBoatInfo(0);
      });

      // this.map.on('zoom', this.updateIconStyle(this));        
      this.map.on('zoomend',()=>{
        console.log("this.map.getZoom() = " + this.map.getZoom());

        // ATTENZIONE NON CANCELLARE
        // Queste righe abilitano visualizzazione topLayer openstreenmap per zoom profondi
        // Non lo abilito di defualt perchè la grafica windy diventa molto brutta....
        if (this.map.getZoom() >= 12) {
          // topLayer.setOpacity('1');
          OpenStreetMap_Mapnik.setOpacity('1'); // Per adesso NON lo rendo visible
          // OpenSeaMap.setOpacity('1');     // Per adesso NON lo rendo visible
        } else {
          // topLayer.setOpacity('0');
          OpenStreetMap_Mapnik.setOpacity('0'); // Per adesso NON lo rendo visible
          // OpenSeaMap.setOpacity('0'); // Per adesso NON lo rendo visible
        }
       
      });
      
      // Evento pressione tast destro
      this.map.on('contextmenu',(e)=>{
        // console.log("this.map.contextmenu = " + this.map.getZoom() + "lat/lon=" + this.map);
        // console.log(e);
        // console.log("(Lat:"+e.latlng.lat + ",Lon:" + e.latlng.lng + ",Zoom=" + this.map.getZoom()+")");
        console.log("Map center=" + this.map.getCenter() + " Map zoom=" + this.map.getZoom());
        
        // Tentativo di utilizzo picker !!! Sembra funzionare !
        this.windyAPI.picker.open({"lat":e.latlng.lat,"lon":e.latlng.lng});
        
        // Aggiorno comunque la posizione cursore 
        this.api.mapMouseLat = e.latlng.lat;
        this.api.mapMouseLon = e.latlng.lng;
        
        // Tentativo di lettura dati overlay meteo...non sembra funzionare...
        // console.log(this.windyAPI.overlays);
        // console.log(this.windyAPI.broadcast);
        // console.log(this.windyAPI.picker.getParams());
        // let windObject = this.windyAPI.utils.wind2obj(this.windyAPI.overlays.wind.convertValue())
        // console.log(windObject);
        // console.log(this.windyAPI.utils.wind2obj({"lat":e.latlng.lat,"lon":e.latlng.lng}));
      });

      // console.log ("Last line of WindyInit callback...2");

      // document.getElementById("customerlogoLarge").style.visibility = "hidden";
      // document.getElementById("mobile-ovr-select").style.position = "absolute";
      
      // document.getElementById("mobile-ovr-select").style.right = "150px";
      document.getElementById("mobile-ovr-select").style.top = "160px";
      document.getElementById("embed-zoom").style.top = "190px";
      // document.getElementById("mobile-ovr-select").style.left = "150px";
      
      // document.getElementById("logo").style.transform = "scale(.5, .5)";
      // document.getElementById("logo").style.transform = "translateY(-100%);";
      // document.getElementById("logo").style.marginLeft = "-20px";
      // document.getElementById("logo").style.left = "0px";

      // document.getElementById("logo-wrapper").classList.remove("top-border");
      // document.getElementById("logo-wrapper").classList.add("bottom-border");

      // FUNZIONA LOGO IN BASSO A DESTRA
      document.getElementById("logo-wrapper").style.position="fixed";
      document.getElementById("logo-wrapper").style.bottom="10px";  
      document.getElementById("logo-wrapper").style.top="unset";
      document.getElementById("logo-wrapper").style.left="0px";
      document.getElementById("logo-wrapper").style.right="0px";
      
      document.getElementById("logo").style.transform = "scale(.5, .5)";
      document.getElementById("logo").style.position="fixed";
      document.getElementById("logo").style.left="-15px";
      document.getElementById("logo").style.bottom="70px"; // 35
      document.getElementById("logo").style.top="unset";
      document.getElementById("logo").style.marginLeft="0px";

      // document.getElementById("progress-bar").style.left = "80px";
      document.getElementById("progress-bar").style.left = "0px";  

      // Non riesco a spostare in basso a destra !!!

      // NON FUNZIONA, serve relativo
      // document.getElementById("logo").style.top = (window.innerHeight - 75).toString() + "px";
      // document.getElementById("logo").style.bottom = "200px";
      // document.getElementById("logo").style.top = "auto";

      // document.getElementById("logo").style.top = "auto";
      // document.getElementById("logo").style.bottom = "100px";
      
      
      // document.getElementById("customerlogoSmall").style.visibility = "hidden";
      // document.getElementById("customerlogoLarge").style.visibility = "hidden";
      // document.getElementById("customerlogoLarge").style.width = "10%";

      
      
      // document.getElementById("mobile-ovr-select").style.left = "50px";

      // document.getElementById("logo").style.top = "150px";
      // document.getElementById("bottom").style.visibility = "hidden";
      // document.getElementById("mobile-ovr-select").style.visibility = "hidden";
      // document.getElementById("embed-zoom").style.visibility = "hidden";

      this.api.mapReadyStatus = 1;  // 1= Windy OK, ancora non chiamata MapRedraw

    });
  }  
  //---------------------------------------------------------------------------
  bearing(latlng1, latlng2) {
    var rad = Math.PI / 180,
        lat1 = latlng1.lat * rad,
        lat2 = latlng2.lat * rad,
        lon1 = latlng1.lng * rad,
        lon2 = latlng2.lng * rad,
        y = Math.sin(lon2 - lon1) * Math.cos(lat2),
        x = Math.cos(lat1) * Math.sin(lat2) -
            Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1);

    var bearing = ((Math.atan2(y, x) * 180 / Math.PI) + 360) % 360;
    // Commento originale trasformazione +-180° in 0-360
    // return bearing >= 180 ? bearing-360 : bearing;
    return bearing;       

  }
  //---------------------------------------------------------------------------
  mainTimer(s){
    
    // L'applicazione viene ridisegnata su evento di ricezione nuovi dati
    // Per adesso nel timer non viene svolta alcuna azione salvo eventuale aggiornamento playback.
    // console.log("MainTimer - this.api.lastUpdateDateTimeString="+this.api.lastUpdateDateTimeString);
    

  }
  //---------------------------------------------------------------------------
  mapRedraw(boats) {

    // Disegno markers e polilinee mappa

    // Rileggo trackPolylineMaxAge
    if (this.api.event.trackinginterval > 0)
      this.trackPolylineMaxAge = this.api.event.trackinginterval * 2;
    else
      this.trackPolylineMaxAge = 1800;
    
    // Disegno percorso
    // Elimino e poi ricreo polilinea e marker della rotta evento
    /*
    if (this.routePolylineLayer!=0) {
      this.map.removeLayer(this.routePolylineLayer); 
    }  
    if (this.routeMarkers.length>0) {
      for (let i=0;i<this.routeMarkers.length;i++)
        this.map.removeLayer(this.routeMarkers[i]); 
    }
    let polylineArray =[];
    let newPolyline:any = 0;  // ATTENZIONE devi usare let !!
    for (let i=0;i<this.api.event.markers.length;i++)   {
      let markerLatLng = L.latLng(this.api.event.markers[i].lat,this.api.event.markers[i].lon);
      polylineArray.push(markerLatLng);
      let markerIcon = L.divIcon({html: this.routeMarkerIcon,iconSize: [8,24],iconAnchor: [4,12],popupAnchor: [0,0],});
      this.routeMarkers[i] = L.marker(markerLatLng, {icon: markerIcon,title:this.api.event.markers[i].name});
      this.routeMarkers[i].addTo(this.map);
    }
    newPolyline = L.polyline(polylineArray, {color: "red",weight: 2,});
    newPolyline.addTo(this.map);      
    newPolyline.on('mouseover', function (e) {
      newPolyline.setStyle({weight: 4,});
    });
    newPolyline.on('mouseout', function (e) {
      newPolyline.setStyle({weight: 2,});
    });
    this.routePolylineLayer = newPolyline;  // Assegno solo alla fine, se non passo attraverso "let newPolyline" non funzionano gli eventi!
    */

  // if (this.routePolylineLayer!=0) {
  //   this.map.removeLayer(this.routePolylineLayer); 
  // }  
  if (this.routeMarkers.length>0) {
    for (let i=0;i<this.routeMarkers.length;i++)
      this.map.removeLayer(this.routeMarkers[i]); 
  }
  let polylineArray =[];
  let newPolyline:any = 0;  // ATTENZIONE devi usare let !!
  for (let i=0;i<this.api.event.markers.length;i++)   {
    let markerLatLng = L.latLng(this.api.event.markers[i].lat,this.api.event.markers[i].lon);
    let markerIcon = L.divIcon({html: this.routeMarkerIcon,iconSize: [8,24],iconAnchor: [4,12],popupAnchor: [0,0],});
    this.routeMarkers[i] = L.marker(markerLatLng, {icon: markerIcon,title:this.api.event.markers[i].name});
    this.routeMarkers[i].addTo(this.map);
  }
  
  // Creo array di comoddo che contiene tutti i nomi delle imbarcazioni con classe "MARKER"
  // Mi serve per accelerare la ricerca dei marker che devono essere duisegnati in giallo
  // perchè associati ad una imbarcazione/boa che fornisce la posizione dinamica. 
  // Voglio evitare di eseguire scansione tutte le volte su tutte le barche
  /*
  TODO DA RIPROVARE 
  var boatWithMarkerClass = [];
  for (let i=0;i<boats.length;i++) {
    if (boats.class == "MARKER")
    boatWithMarkerClass.push(boats.name);
  }    
  
  // Scansione di tutti i marker e creazione delle icone relative.
  for (let i=0;i<this.api.event.markers.length;i++)   {
    let markerLatLng = L.latLng(this.api.event.markers[i].lat,this.api.event.markers[i].lon);
    let markerIcon = L.divIcon({html: this.routeMarkerIcon,iconSize: [8,24],iconAnchor: [4,12],popupAnchor: [0,0],});
    this.routeMarkers[i] = L.marker(markerLatLng, {icon: markerIcon,title:this.api.event.markers[i].name});
    this.routeMarkers[i].addTo(this.map);
  }
  */
  
  
  
  // newPolyline = L.polyline(polylineArray, {color: "red",weight: 2,});
  // newPolyline.addTo(this.map);      
  // newPolyline.on('mouseover', function (e) {
    // newPolyline.setStyle({weight: 4,});
  // });
  // newPolyline.on('mouseout', function (e) {
    // newPolyline.setStyle({weight: 2,});
  // });
  // this.routePolylineLayer = newPolyline;  // Assegno solo alla fine, se non passo attraverso "let newPolyline" non funzionano gli eventi!


    // Rimuovo da mappa imbarcazioni e polilinea ultime posizioni
    for (let i=0;i<this.api.boatsLayer.length;i++)
    {
      if (this.api.boatsLayer[i].marker != 0)
        this.map.removeLayer(this.api.boatsLayer[i].marker); 
      if (this.api.boatsLayer[i].polyline != 0)
         this.map.removeLayer(this.api.boatsLayer[i].polyline); 
    }

    // Cancello array per ogni barca contenente informazioni marker e polilinea
    this.api.boatsLayer = [];

    // Ogni icona viene ruotata secondo l'heading calcolato tra gli ultimi punti
    let lastTrackId = 0;

    // for (let i=0;i<1;i++) {
    for (let i=0;i<boats.length;i++) {

      var iconHtml = boats[i].iconHtml;
      var boatIcon = L.divIcon({html: iconHtml,iconSize: [8,24],iconAnchor: [4,12],popupAnchor: [0,0],});
      var heading = 0;
      lastTrackId = boats[i].track_epoch.length -1;  // Il playback è stato spostao nella api, leggo sempre ultimo dato !!!
      if (lastTrackId>=1)
      {
        if (boats[i].track_latlon[lastTrackId-1]==undefined)
        {
          console.log(boats[i]);
          console.log("undefined i= " + i + " / dev_sn=" + boats[i].dev_sn);
          continue;
        }
        else  
          heading = this.bearing(L.latLng(boats[i].track_latlon[lastTrackId-1]),L.latLng(boats[i].track_latlon[lastTrackId]));
      }
      else
        heading = 0;
      
      // Disegno marker e polilinea solo se è presente almeno un punto della traccia
      if (lastTrackId >= 0)
      {
        let newMarker : any = 0;
        if (boats[i].track_latlon.length > 0)
        {
          newMarker = L.marker(boats[i].track_latlon[lastTrackId], {
            icon: boatIcon,
            // title:boats[i].name,
            rotationAngle: heading, // Proprietà aggiunta dal plugin "leaflet rotated marker"
          });
          
          newMarker.boatId = i;
          newMarker.showPopup = false;

          /*
          // ATTENZIONE NON CANCELLARE !!!
          newMarker.bindPopup(boats[i].class  + "</br>" +
            boats[i].name + "</br>" + 
            boats[i].sailn  + "</br>" +
            "Lat: " + boats[i].track_latlon[lastTrackId][0].toFixed(4) + "</br>"+
            "Lon: " + boats[i].track_latlon[lastTrackId][1].toFixed(4) + "</br>"+
            "Heading: " + heading.toFixed(0) + "°</br>" +
            "Last position: " + moment.unix(boats[i].track_epoch[lastTrackId]).format("DD/MM/YY HH:mm")+ "</br>"
          );
          */

          // ATTENZIONE, devo definire una variabile per passare riferimento a contest
          var _parentContext = this;
          // ATTENZIONE, per leaflet mouseover=mouseenter e mouseout=mouseleave !!!
          newMarker.on('mouseover', function(e){  
            // _parentContext.showBoatInfo(i,e.originalEvent.pageX,e.originalEvent.pageY);
            // _parentContext.showBoatFullTrack(i);
            _parentContext.showBoatInfo(i,e.originalEvent.pageX,e.originalEvent.pageY);
            _parentContext.api.leaderBoardBoatClick(i,"mouseenter");
            // console.log(e);
          });
          newMarker.on('mouseout', function(e){
            // _parentContext.hideBoatInfo(i);
            // _parentContext.hideBoatFullTrack(i);
            _parentContext.hideBoatInfo(i);
            _parentContext.api.leaderBoardBoatClick(i,"mouseleave");
          });

          newMarker.on('click', function(e){
            // console.log("mousedown");
            // Blocco la propagazione evento al windy che altrimenti mostra intensità vento !!
            // e.originalEvent.stopPropagation();  // ATTENZIONE deve essere chiamato subito, prima di showBoatInfo() !!!
            _parentContext.showBoatInfo(i,e.originalEvent.pageX,e.originalEvent.pageY);
            _parentContext.api.leaderBoardBoatClick(i,"click");
            // _parentContext.showBoatFullTrack(i);
            return(false);
            // console.log(e);
          });
          // NON CANCELLARE !!!
          // newMarker.on('mousedown', function(e){
          //   // console.log("mousedown");
          //   // Blocco la propagazione evento al windy che altrimenti mostra intensità vento !!
          //   e.originalEvent.stopPropagation();  // ATTENZIONE deve essere chiamato subito, prima di showBoatInfo() !!!
          //   _parentContext.showBoatInfo(i,e.originalEvent.pageX,e.originalEvent.pageY);
          //   // console.log(e);
          // });
        }

        // Creo polilinea con ultime posizioni
        // Se ci sono almeno due punti posso disegnare polilinea...
        // Aggiungo solo i punti con data non più vecchia dell'ultima posizione - trackPolylineMaxAge
        let newPolyline:any = 0;  // ATTENZIONE devi usare let !!
        
        
        if (lastTrackId > 1) {
        // if ((lastTrackId > 1) && ( boats[i].class !="Marker")) {
          let polylineArray =[];
          // Creo la polilinea leggendo i punti epoch a ritroso da ultima posizione
          for (let j=lastTrackId;j>=0;j--){
            if (boats[i].track_epoch[j] >(boats[i].track_epoch[lastTrackId]-this.trackPolylineMaxAge)) {
              polylineArray.push(boats[i].track_latlon[j]);
            }
            else {
              break;
            }
          }
          newPolyline = L.polyline(polylineArray, {
              color: boats[i].iconColor,
              weight: 2,
          });

          newPolyline.on('mouseover', function (e) {
              newPolyline.setStyle({weight: 4,});
          });
          newPolyline.on('mouseout', function (e) {
              newPolyline.setStyle({weight: 2,});
          });
        }
        else 
          newPolyline = 0;

        this.api.boatsLayer.push({
          marker: newMarker,
          polyline: newPolyline,
        });
      }
      else {
        // ATTENZIONE, aggiungo comunque un elemento per ogni barca per mantenere il colore assegnato
        // In questo modo i colori assegnati non cambiano nel caso qualche barca trasmetta il primo punto in ritardo.
        
        let newPolyline:any = 0;  // ATTENZIONE devi usare let !!
        
        this.api.boatsLayer.push({
          // heading: 0,
          // color: this.api.boats[i].color,
          // navStatus: boats[i].navStatus,
          marker: 0,
          polyline: newPolyline,
        });
      }

      // Aggiungo a posteriori controllo visibilità polilinea
      /*
      if (boats[i].fullTrackVisible == true) {
        // console.log("mapRedraw::showBoatFullTrack for i=" + i);
        this.showBoatFullTrack(i);
      }  
      */

    }

    // Aggiungo i layer su mappa solo se l'imbarcazione è visibile
    // ATTENZIONE ATTENZIONE TODO
    // boats[].visible potrebbe non bastare a rendere visibile imbarcazione/traccia
    // La leaderboar può applicare anche un filtro che successivamente rende invisibili le barche non selezionate
    for (let i=0;i<this.api.boatsLayer.length;i++) {
      if ((this.api.boatsLayer[i].marker != 0)&&(this.api.boats[i].visible)) {
        this.api.boatsLayer[i].marker.addTo(this.map);
      }
      if ((this.api.boatsLayer[i].polyline != 0)&&(this.api.boats[i].visible)) {
        this.api.boatsLayer[i].polyline.addTo(this.map)
      }        
    }
    // console.log("mapRedraw has updated visibility");
    // console.log(this.api.boats);
    // console.log("debug");


    // let debug = document.getElementById("mobile-ovr-select");
    // console.log(debug);
    // let debug = window.getComputedStyle(document.getElementById("logo")); // window.getComputedStyle(element[, pseudoElt]).
    // console.log(debug);

    // console.log(document.getElementById("logo"));
    // document.getElementById("logo").style.top = "150px";
    // console.log(document.getElementById("logo").style);

    // debug = document.getElementById("bottom").style;
    // console.log(debug);

  }
  //---------------------------------------------------------------------------
  showBoatInfo(boatId,x,y)  
  {
    // Assegno alla finestra l'oggetto corrispondente alla barca desiderata
    this.boatInfo = this.api.boats[boatId];
    
    // Ricerco ed assegno indice nella leaderboard, dipende dall'ultimo ordinamento fatto
    // LO volgio mostrare nella finestra
    // this.boatInfo.orderId = -1;
    for (let i=0;i<this.api.boatsLeaderBoards.length;i++){
      if (this.api.boatsLeaderBoards[i].boatId == boatId) {
        this.boatInfo.orderId = i + 1 ; // Nell'ordinare si parte da 1....
        break;
      }      
    }

    // Devo controllare le coordinate e riposizionare lontano dal bordo
    if ((x  + this.boatInfoWidth  + 16) < this.map._container.clientWidth)
      this.boatInfoX  = x + 16;
    else
      this.boatInfoX  = x - this.boatInfoWidth - 16;

    if ((y  + this.boatInfoHeight  + 16) < this.map._container.clientHeight)
      this.boatInfoY  = y;
    else
      this.boatInfoY  = y - this.boatInfoHeight - 16;

    // Controllo posizionamento verticoale fuori schermo
    if (this.boatInfoY < 0)  
      this.boatInfoY = 0;

    // if (this.boatInfoY > (this.map._container.clientHeight - this.boatInfoHeight))
    //   this.boatInfoY = this.map._container.clientHeight - this.boatInfoHeight;

    // this.boatInfoY = y;
    this.boatInfoVisible = true;
    this.boatInfoVisibleStyle = "visible";
    this.boatInfoId = boatId;
    // console.log("showBoatInfo for boatId = " + boatId + " at position x=" + x + " y="+y);

  }
  //---------------------------------------------------------------------------
  hideBoatInfo(boatId)  
  {
    // La finestra "scompare" grazie al change detection di angular...
    this.boatInfoVisible = false;
    this.boatInfoVisibleStyle = "hidden";
    this.boatInfoId = -1;

  }
  //---------------------------------------------------------------------------
  showBoatFullTrack(boatId)  
  {
    
    // Mostro la traccia riscrivendo la polilinea con tutti i dati posizione
    let polylineArray =[];
    // Creo la polilinea leggendo tutti i punti disponibili
    for (let j=0;j<this.api.boats[boatId].track_latlon.length;j++){
        polylineArray.push(L.latLng(this.api.boats[boatId].track_latlon[j][0],this.api.boats[boatId].track_latlon[j][1]));
    }
    if ((this.api.boats[boatId].track_latlon.length > 0)&&(this.api.boatsLayer[boatId].polyline != 0))
      this.api.boatsLayer[boatId].polyline.setLatLngs(polylineArray);
    
      this.api.setBoatFullTrackVisibility(boatId,true);  
    // console.log("showBoatFullTrack::this.api.boats[" + boatId +"].fullTrackVisible="+this.api.boats[boatId].fullTrackVisible);

  }
  //---------------------------------------------------------------------------
  hideBoatFullTrack(boatId)  
  {
    
    // Nascondo la traccia riscrivendo la polilinea con gli ultimi this.trackPolylineMaxAge
    let polylineArray =[];
    let lastTrackId = this.api.boats[boatId].track_epoch.length -1;

    for (let j=lastTrackId;j>=0;j--){
      if (this.api.boats[boatId].track_epoch[j] >(this.api.boats[boatId].track_epoch[lastTrackId]-this.trackPolylineMaxAge)) {
        polylineArray.push(L.latLng(this.api.boats[boatId].track_latlon[j][0],this.api.boats[boatId].track_latlon[j][1]));
      }
      else {
        break;
      }
    }
    if ((lastTrackId>0)&&(this.api.boatsLayer[boatId].polyline != 0))
      this.api.boatsLayer[boatId].polyline.setLatLngs(polylineArray);

      
    this.api.setBoatFullTrackVisibility(boatId,false);
    //console.log("hideBoatFullTrack::this.api.boats[" + boatId +"].fullTrackVisible="+this.api.boats[boatId].fullTrackVisible);

  }
  //---------------------------------------------------------------------------
  openDialog(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    this.dialog.open(DialogComponent,dialogConfig);
    
  }
  //---------------------------------------------------------------------------
  mapMouseMove(e) {
    // let position: any;
    // position = L.point(this.map.latLngToContainerPoint(this.api.boatsLayer[boatId].marker._latlng));
    // this.showBoatInfo(boatId,position.x,position.y); 
    // console.log(e);
    if (this.map == undefined)
      return;

    let point = L.point(e.screenX,e.screenY);
    // let latlng = L.layerPointToLatLng(point);
    let latlng = this.map.layerPointToLatLng(point);
    this.api.mapMouseLat = latlng.lat;
    this.api.mapMouseLon = latlng.lng;


    // SOLO PER DEBUG
    // this.api.mapCenterZoomString = this.map.getCenter() + " / " + this.map.getZoom();


    // console.log(this.api.mapMouseLat + " / " + this.api.mapMouseLon);
    // console.log(latlng);
    
    // NON ABILITARE anche se funziona, troppo gravoso nell'evento mousemove...
    // Tentativo di utilizzo picker !!! Sembra funzionare !
    // this.windyAPI.picker.open({"lat":latlng.lat,"lon":latlng.lng});

    // layerPointToLatLng(<Point> point)
  }
  //---------------------------------------------------------------------------
  playbackRangeInputChange($event){
    // console.log($event);
    this.api.playbackEpochChange(parseInt($event.target.value));
  }
  //---------------------------------------------------------------------------

}
